module.exports = __webpack_public_path__ + "img/option-5.00a5e5d5.png";